import * as React from 'react';
import StreetAddress, { StreetAddressViewModel } from '../StreetAddress';
import { DatePicker, TimePicker } from '@progress/kendo-react-dateinputs';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import * as moment from 'moment';
import WeightInput from '../WeightInput';
import LengthInput from '../LengthInput';

export type ChildViewModel = {
    FirstName: string;
    LastName: string;
    Gender: number | null;
    BirthDate: Date | null;
    Phone: string;
    HomeAddress: StreetAddressViewModel;
    Breakfast: string;
    HasBreakfast: boolean;
    Lunch: string;
    HasLunch: boolean;
    Snack: string;
    HasSnack: boolean;
    NapOne1: Date | null;
    NapOne2: Date | null;
    NapTwo1: Date | null;
    NapTwo2: Date | null;
    NapThree1: Date | null;
    NapThree2: Date | null;
    BottleOne: Date | null;
    BottleTwo: Date | null;
    BottleThree: Date | null;
    EmergencyFirstName: string;
    EmergencyLastName: string;
    EmergencyPhone: string;
    EmergencyRelation: string;
    EmergencyAddress: StreetAddressViewModel | null;
    DoctorFirstName: string;
    DoctorLastName: string;
    DoctorPhone: string;
    DoctorAddress: StreetAddressViewModel | null;
    Healthcard: string;
    Height: number;
    HeightUnitOfMeasure: number;
    Weight: number;
    WeightUnitOfMeasure: number;
    Disability: string;
    Chronic: string;
    Disorder: string;
    Medication: string;
    Allergies: string;
    Dietary: string;
    Other: string;
    HasDisability: boolean;
    HasChronic: boolean;
    HasDisorder: boolean;
    HasMedication: boolean;
    HasAllergies: boolean;
    HasDietary: boolean;
    HasMeasles: boolean;
    HasChickenPox: boolean;
    HasScarletFever: boolean;
    HasGermanMeasles: boolean;
    HasWhoopingCough: boolean;
    HasOther: boolean;
    Note: string;
}

type Props = {
    Validation: boolean;
    child: ChildViewModel;
    index: number;
    onChange: (newAddress: ChildViewModel) => void;
    academicUser: boolean;
}

export default class RegistrationChild extends React.Component<Props>{

    constructor(props: Props) {
        super(props);

        this.setGender = this.setGender.bind(this);
    }

    public render() {
        return <React.Fragment>
            <h5 className="information">Child's Information</h5>
            <div className="card">
                <div className="card-body">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Name<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <input
                            className="form-control"
                            type="text"
                            name={`Children[${this.props.index}].FirstName`}
                            placeholder="First Name"
                            value={this.props.child.FirstName}
                            onChange={(e) => this.updateChild({ FirstName: e.target.value })}
                        />
                        <input
                            className="form-control"
                            type="text"
                            name={`Children[${this.props.index}].LastName`}
                            placeholder="Last Name"
                            value={this.props.child.LastName}
                            onChange={(e) => this.updateChild({ LastName: e.target.value })}
                        />
                    </div>
                    {this.props.Validation && !this.props.child.FirstName && !this.props.child.LastName && <p className="error-msg">First and Last Name are Required</p>}
                    {this.props.Validation && !this.props.child.FirstName && this.props.child.LastName && <p className="error-msg">First Name is Required</p>}
                    {this.props.Validation && this.props.child.FirstName && !this.props.child.LastName && <p className="error-msg">Last Name is Required</p>}
                    {this.props.Validation && this.props.child.FirstName && this.props.child.LastName && <br/> || !this.props.Validation && <br/>}
                    <div className="k-form-field" onChange={this.setGender}>
                        <span>Gender<span style={{ color: '#dc3545' }}>*</span></span>
                        <input
                            type="radio"
                            name={`Children[${this.props.index}].Gender`}
                            id={`Children[${this.props.index}].Female`}
                            value="1"
                            className="k-radio"
                        />
                        <label className="k-radio-label" htmlFor={`Children[${this.props.index}].Female`} >Female</label>
                        <input
                            type="radio"
                            name={`Children[${this.props.index}].Gender`}
                            id={`Children[${this.props.index}].Male`}
                            value="0"
                            className="k-radio"
                        />
                        <label className="k-radio-label" htmlFor={`Children[${this.props.index}].Male`}>Male</label>
                        {this.props.Validation && this.props.child.Gender !== 0 && this.props.child.Gender !== 1 && <div><p className="error-msg">Gender is Required</p></div>}
                    </div>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Date of Birth<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <DatePicker
                            format="MM/dd/yyyy"
                            max={moment().toDate()}
                            name={`Children[${this.props.index}].BirthDate`}
                            formatPlaceholder="formatPattern"
                            value={this.props.child.BirthDate}
                            onChange={(e) => this.updateChild({ BirthDate: e.value })}
                        />
                    </div>
                    {(this.props.Validation && !this.props.child.BirthDate) ? <p className="error-msg">Date of Birth is Required</p> : <br/>}
                    <label>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Home Phone Number<div style={{ color: '#dc3545' }}>*</div></span>
                            </div>
                            <MaskedTextBox
                                mask="(000)000-0000"
                                name={`Children[${this.props.index}].Phone`}
                                placeholder="(000)000-0000"
                                value={this.props.child.Phone}
                                onChange={(e) => this.updateChild({ Phone: e.target.value.replace(/_/g, "") })}
                            />
                        </div>
                    </label>
                    {(this.props.Validation && (!this.props.child.Phone || this.props.child.Phone.length < 13)) ? <p className="error-msg error">Home Phone is Required</p> : <br/>}
                    <StreetAddress
                        validation={this.props.Validation}
                        address={this.props.child.HomeAddress}
                        onChange={(newAddress) => this.updateChild({ HomeAddress: newAddress })}
                        title="Home Address"
                        index={this.props.index}
                        required
                    />
                </div>
            </div>
            <br/>
            {!this.props.academicUser && <React.Fragment>
                <br/>
                <div>
                    <h5 className="infant">Infant Daily Schedule</h5>
                    <div className="card">
                        <div className="card-body">
                            <h6>When does your child eat?</h6>
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="Breakfast" className="k-checkbox" checked={this.props.child.HasBreakfast} onChange={(e) => this.updateChild({HasBreakfast: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="Breakfast">Breakfast</label>
                            </label>
                            {this.props.child.HasBreakfast &&
                            <textarea
                                name="breakfast"
                                className="form-control"
                                placeholder="Describe meal"
                                value={this.props.child.Breakfast}
                                onChange={(e) => this.updateChild({ Breakfast: e.target.value })}
                            />}
                        {this.props.child.HasBreakfast && <br/>}
                            <label className="k-form-field">
                                <input type="checkbox" id="Lunch" className="k-checkbox" checked={this.props.child.HasLunch} onChange={(e) => this.updateChild({HasLunch: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="Lunch">Lunch</label>
                            </label>
                            {this.props.child.HasLunch &&
                            <textarea
                                name="lunch"
                                className="form-control"
                                placeholder="Describe meal"
                                value={this.props.child.Lunch}
                                onChange={(e) => this.updateChild({ Lunch: e.target.value })}
                            />}
                        {this.props.child.HasLunch && <br/>}
                            <label className="k-form-field">
                                <input type="checkbox" id="Snack" className="k-checkbox" checked={this.props.child.HasSnack} onChange={(e) => this.updateChild({HasSnack: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="Snack">Afternoon Snack</label>
                            </label>
                            {this.props.child.HasSnack &&
                            <textarea
                                name="snack"
                                className="form-control"
                                placeholder="Describe meal"
                                value={this.props.child.Snack}
                                onChange={(e) => this.updateChild({ Snack: e.target.value })}
                            />}
                            {this.props.child.HasSnack && <br/>}
                            <br/>
                            <h6>When does your child nap?</h6>
                            <br/>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">From</span>
                                </div>
                                <TimePicker
                                    name="Nap"
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    className="form-control"
                                    value={this.props.child.NapOne1}
                                    onChange={(e) => this.updateChild({ NapOne1: e.target.value})}
                                />
                                <div className="input-group-prepend">
                                    <span className="input-group-text inputGroupPrepend">To</span>
                                </div>
                                <TimePicker
                                    name="Nap"
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    className="form-control"
                                    value={this.props.child.NapOne2}
                                    onChange={(e) => this.updateChild({ NapOne2: e.target.value})}
                                />
                            </div>
                            <br/>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">From</span>
                                </div>
                                <TimePicker
                                    name="Nap"
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    className="form-control"
                                    value={this.props.child.NapTwo1}
                                    onChange={(e) => this.updateChild({ NapTwo1: e.target.value})}
                                />
                                <div className="input-group-prepend">
                                    <span className="input-group-text">To</span>
                                </div>
                                <TimePicker
                                    name="Nap"
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    className="form-control"
                                    value={this.props.child.NapTwo2}
                                    onChange={(e) => this.updateChild({ NapTwo2: e.target.value})}
                                />
                            </div>
                            <br/>
                            <div className="input-group a">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">From</span>
                                </div>
                                <TimePicker
                                    name="Nap"
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    className="form-control"
                                    value={this.props.child.NapThree1}
                                    onChange={(e) => this.updateChild({ NapThree1: e.target.value})}
                                />
                                <div className="input-group-prepend">
                                    <span className="input-group-text">To</span>
                                </div>
                                <TimePicker
                                    name="Nap"
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    className="form-control"
                                    value={this.props.child.NapThree2}
                                    onChange={(e) => this.updateChild({ NapThree2: e.target.value})}
                                />
                            </div>
                            <br/>
                            <h6>When does your child have their bottles?</h6>
                            <br/>
                            <label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">Bottle times</span>
                                    </div>
                                    <TimePicker
                                        name="BottleOne"
                                        className="form-control"
                                        format="hh:mm a"
                                        formatPlaceholder="formatPattern"
                                        value={this.props.child.BottleOne}
                                        onChange={(e) => this.updateChild({ BottleOne: e.target.value})}
                                    />
                                    <TimePicker
                                        name="BottleTwo"
                                        className="form-control"
                                        format="hh:mm a"
                                        formatPlaceholder="formatPattern"
                                        value={this.props.child.BottleTwo}
                                        onChange={(e) => this.updateChild({ BottleTwo: e.target.value})}
                                    />
                                    <TimePicker
                                        name="BottleThree"
                                        format="hh:mm a"
                                        formatPlaceholder="formatPattern"
                                        className="form-control"
                                        value={this.props.child.BottleThree}
                                        onChange={(e) => this.updateChild({ BottleThree: e.target.value})}
                                    />
                                </div>
                            </label>
                        </div>
                    </div>
                    <br/>
                    <br/>
                </div>
            </React.Fragment>}
            <h5 className="emergency">Emergency Contact</h5>
            <div className="card">
                <div className="card-body">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Name<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <input
                            type="text"
                            placeholder="First Name"
                            className="form-control"
                            value={this.props.child.EmergencyFirstName}
                            onChange={(e) => this.updateChild({ EmergencyFirstName: e.target.value })}
                        />
                        <input
                            type="text"
                            placeholder="Last Name"
                            className="form-control"
                            value={this.props.child.EmergencyLastName}
                            onChange={(e) => this.updateChild({ EmergencyLastName: e.target.value })}
                        />
                    </div>
                    {this.props.Validation && !this.props.child.EmergencyFirstName && !this.props.child.EmergencyLastName && <p className="error-msg">First and Last Name are Required</p>}
                    {this.props.Validation && !this.props.child.EmergencyFirstName && this.props.child.EmergencyLastName && <p className="error-msg">First Name is Required</p>}
                    {this.props.Validation && this.props.child.EmergencyFirstName && !this.props.child.EmergencyLastName && <p className="error-msg">Last Name is Required</p>}
                    {this.props.Validation && this.props.child.EmergencyFirstName && this.props.child.EmergencyLastName && <br/> || !this.props.Validation && <br/>}
                    <label>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Phone Number<div style={{ color: '#dc3545' }}>*</div></span>
                            </div>
                            <MaskedTextBox
                                mask="(000)000-0000"
                                name="Phone"
                                placeholder="(000)000-0000"
                                value={this.props.child.EmergencyPhone}
                                onChange={(e) => this.updateChild({ EmergencyPhone: e.target.value.replace(/_/g, "") })}
                            />
                        </div>
                    </label>
                    {(this.props.Validation && (!this.props.child.EmergencyPhone || this.props.child.EmergencyPhone.length < 13)) ? <p className="error-msg">Phone Number is Required</p> : <br/>}
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Relationship to Child<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <label id="name"></label>
                        <input
                            type="string"
                            name="name"
                            placeholder="Grandparent, Family Friend, etc..."
                            className="form-control"
                            value={this.props.child.EmergencyRelation}
                            onChange={(e) => this.updateChild({ EmergencyRelation: e.target.value })}
                        />
                    </div>
                    {(this.props.Validation && !this.props.child.EmergencyRelation) ? <p className="error-msg">Relationship to Child is Required</p> : <br/>}
                    <StreetAddress
                        address={this.props.child.EmergencyAddress}
                        onChange={(newAddress) => this.updateChild({ EmergencyAddress: newAddress })}
                        title="Emergency Address"
                        validation={this.props.Validation}
                        index={this.props.index}
                    />
                </div>
            </div>
            <br/>
            {!this.props.academicUser && <React.Fragment>
                <br/>
                <h5 className="medical">Medical Information</h5>
                <div className="card">
                    <div className="card-body">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Health Card Number<div style={{ color: '#dc3545' }}>*</div></span>
                            </div>
                            <MaskedTextBox
                                mask="0000-000-000-LL"
                                name={`Children[${this.props.index}].Healthcard`}
                                placeholder="0000-000-000-AA"
                                value={this.props.child.Healthcard}
                                onChange={(e) => this.updateChild({ Healthcard: e.target.value.replace(/_/g, "") })}
                            />
                        </div>
                        {(this.props.Validation && !this.props.academicUser && (!this.props.child.Healthcard || this.props.child.Healthcard.length < 15)) ? <p className="error-msg">Health Card is Required</p> : <br/>}
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Height</span>
                            </div>
                            <LengthInput type={this.props.child.HeightUnitOfMeasure} value={this.props.child.Height} onChange={(value) => this.updateChild({ Height: value.value, HeightUnitOfMeasure: value.type })} />
                        </div>
                        <br/>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Weight</span>
                            </div>
                            <WeightInput type={this.props.child.WeightUnitOfMeasure} value={this.props.child.Weight} onChange={(value) => this.updateChild({ Weight: value.value, WeightUnitOfMeasure: value.type })} />
                        </div>
                        <br/>
                        <h6>Does your child have any </h6>
                        <br/>
                        <div className="form-group">
                            <label className="k-form-field">
                                <input type="checkbox" id="disability" className="k-checkbox" checked={this.props.child.HasDisability} onChange={(e) => this.updateChild({HasDisability: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="disability">Phyiscal Disabilities?</label>
                            </label>
                            {this.props.child.HasDisability &&
                            <textarea
                                name="Disability"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.props.child.Disability}
                                onChange={(e) => this.updateChild({ Disability: e.target.value })}
                            />}
                            {this.props.child.HasDisability && <br/>}
                            <label className="k-form-field">
                                <input type="checkbox" id="chronic" className="k-checkbox" checked={this.props.child.HasChronic} onChange={(e) => this.updateChild({HasChronic: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="chronic">Chronic Health Problems?</label>
                            </label>
                            {this.props.child.HasChronic &&
                            <textarea
                                name="Chronic"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.props.child.Chronic}
                                onChange={(e) => this.updateChild({ Chronic: e.target.value })}
                            />}
                            {this.props.child.HasChronic && <br/>}
                            <label className="k-form-field">
                                <input type="checkbox" id="disorder" className="k-checkbox" checked={this.props.child.HasDisorder} onChange={(e) => this.updateChild({HasDisorder: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="disorder">Emotional Disorders or Behavioral Problems?</label>
                            </label>
                            {this.props.child.HasDisorder &&
                            <textarea
                                name="Disorder"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.props.child.Disorder}
                                onChange={(e) => this.updateChild({ Disorder: e.target.value })}
                            />}
                            {this.props.child.HasDisorder && <br/>}
                            <label className="k-form-field">
                                <input type="checkbox" id="medication" className="k-checkbox" checked={this.props.child.HasMedication} onChange={(e) => this.updateChild({HasMedication: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="medication">Medications?</label>
                            </label>
                            {this.props.child.HasMedication &&
                            <textarea
                                name="Medication"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.props.child.Medication}
                                onChange={(e) => this.updateChild({ Medication: e.target.value })}
                            />}
                            {this.props.child.HasMedication && <br/>}
                            <label className="k-form-field">
                                <input type="checkbox" id="allergies" className="k-checkbox" checked={this.props.child.HasAllergies} onChange={(e) => this.updateChild({HasAllergies: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="allergies">Allergies?</label>
                            </label>
                            {this.props.child.HasAllergies &&
                            <textarea
                                name="Allergies"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.props.child.Allergies}
                                onChange={(e) => this.updateChild({ Allergies: e.target.value })}
                            />}
                            {this.props.child.HasAllergies && <br/>}
                            <label className="k-form-field">
                                <input type="checkbox" id="dietary" className="k-checkbox" checked={this.props.child.HasDietary} onChange={(e) => this.updateChild({HasDietary: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="dietary">Dietary Restrictions?</label>
                            </label>
                            {this.props.child.HasDietary &&
                            <textarea
                                name="Dietary"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.props.child.Dietary}
                                onChange={(e) => this.updateChild({ Dietary: e.target.value })}
                            />}
                            <br/>
                        <h6>Has your child ever had any of these communicable diseases?</h6>
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="measles" className="k-checkbox" checked={this.props.child.HasMeasles} onChange={(e) => this.updateChild({HasMeasles: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="measles">Measles</label>
                            </label>
                            <label className="k-form-field">
                                <input type="checkbox" id="chickenPox" className="k-checkbox" checked={this.props.child.HasChickenPox} onChange={(e) => this.updateChild({HasChickenPox: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="chickenPox">Chicken Pox</label>
                            </label>
                            <label className="k-form-field">
                                <input type="checkbox" id="scarletFever" className="k-checkbox" checked={this.props.child.HasScarletFever} onChange={(e) => this.updateChild({HasScarletFever: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="scarletFever">Scarlet Fever</label>
                            </label>
                            <label className="k-form-field">
                                <input type="checkbox" id="germanMeasles" className="k-checkbox" checked={this.props.child.HasGermanMeasles} onChange={(e) => this.updateChild({HasGermanMeasles: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="germanMeasles">German Measles</label>
                            </label>
                            <label className="k-form-field">
                                <input type="checkbox" id="whoopingCough" className="k-checkbox" checked={this.props.child.HasWhoopingCough} onChange={(e) => this.updateChild({HasWhoopingCough: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="whoopingCough">Whooping Cough</label>
                            </label>
                            <label className="k-form-field">
                                <input type="checkbox" id="other" className="k-checkbox" checked={this.props.child.HasOther} onChange={(e) => this.updateChild({HasOther: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="other">Other</label>
                            </label>
                            {this.props.child.HasOther &&
                            <textarea
                                name="Other"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.props.child.Other}
                                onChange={(e) => this.updateChild({ Other: e.target.value })}
                            />}
                        </div>
                        <br/>
                        <h6>Doctor's Information</h6>
                        <br/>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Name<div style={{ color: '#dc3545' }}>*</div></span>
                            </div>
                            <input
                                type="text"
                                placeholder="First Name"
                                className="form-control"
                                value={this.props.child.DoctorFirstName}
                                onChange={(e) => this.updateChild({ DoctorFirstName: e.target.value })}
                            />
                            <input
                                type="text"
                                placeholder="Last Name"
                                className="form-control"
                                value={this.props.child.DoctorLastName}
                                onChange={(e) => this.updateChild({ DoctorLastName: e.target.value })}
                            />
                        </div>
                        {this.props.Validation && !this.props.academicUser && !this.props.child.DoctorFirstName && !this.props.child.DoctorLastName && <p className="error-msg">First and Last Name are Required</p>}
                        {this.props.Validation && !this.props.academicUser && !this.props.child.DoctorFirstName && this.props.child.DoctorLastName && <p className="error-msg">First Name is Required</p>}
                        {this.props.Validation && !this.props.academicUser && this.props.child.DoctorFirstName && !this.props.child.DoctorLastName && <p className="error-msg">Last Name is Required</p>}
                        {this.props.Validation && !this.props.academicUser && this.props.child.DoctorFirstName && this.props.child.DoctorLastName && <br/> || !this.props.Validation && <br/>}
                        <label>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">Phone Number<div style={{ color: '#dc3545' }}>*</div></span>
                                </div>
                                <MaskedTextBox
                                    mask="(000)000-0000"
                                    name="Phone"
                                    placeholder="(000)000-0000"
                                    value={this.props.child.DoctorPhone}
                                    onChange={(e) => this.updateChild({ DoctorPhone: e.target.value.replace(/_/g, "") })}
                                />
                            </div>
                        </label>
                        {(this.props.Validation && !this.props.academicUser && (!this.props.child.DoctorPhone || this.props.child.DoctorPhone.length < 13)) ? <p className="error-msg">Phone Number is Required</p> : <br/>}
                        <StreetAddress
                            address={this.props.child.DoctorAddress}
                            onChange={(newAddress) => this.updateChild({ DoctorAddress: newAddress })}
                            title="Doctor's Address"
                            validation={this.props.Validation}
                            index={this.props.index}
                        />
                    </div>
                </div>
                <br/>
            </React.Fragment>}
            <div className="form-group">
                <br/>
                <h5 className="comments">Comments</h5>
                <textarea
                    name="Note"
                    className="form-control"
                    value={this.props.child.Note}
                    onChange={(e) => this.updateChild({ Note: e.target.value })}
                />
            </div>
            <br/>
        </React.Fragment>
    }

    private setGender(e: any) {
        this.props.onChange(Object.assign({}, this.props.child, { Gender: parseInt(e.target.value) }));
    }

    private updateChild(value: Partial<ChildViewModel>) {
        const newChild = Object.assign({}, this.props.child, value);
        this.props.onChange(newChild);
    }
}
